import dayjs, { Dayjs } from 'dayjs';
import { AccountData, PeriodModel } from './leaderboard.interfaces';
import { getDateTimeAsString, isDefined } from '@stillmandigital/common';
import { range, round } from 'lodash';
import { VolumeStatisticDto } from '@api/core';

const DATE_STRING_FORMAT = 'YYYY-MM-DD';

export interface DateRange {
  fromTime: Dayjs;
  toTime: Dayjs;
}

export function toPeriodModel(dateRange: DateRange, name?: string): PeriodModel {
  const fromTime = getDateTimeAsString(dateRange.fromTime.toDate(), '00:00:00');
  const toTime = getDateTimeAsString(dateRange.toTime.add(1, 'day').toDate(), '00:00:00');

  return {
    id: getPeriodId(dateRange),
    name: name || getPeriodName(dateRange),
    fromTime,
    toTime,
  };
}

export function getPeriodId({ fromTime, toTime }: DateRange): string {
  return `${fromTime.format(DATE_STRING_FORMAT)}_${toTime.format(DATE_STRING_FORMAT)}`;
}

export function getPeriodName({ fromTime }: DateRange): string {
  return fromTime.format('MMMM YY');
}

export function getInitialPeriods(): PeriodModel[] {
  const PERIOD_OFFSET = -6;
  const today = dayjs();

  return range(PERIOD_OFFSET).map(offset => {
    const fromTime = today.add(offset, 'month').startOf('month');
    const toTime = today.add(offset, 'month').endOf('month');

    return toPeriodModel({ fromTime, toTime });
  });
}

export function toLeaderboardData(models: VolumeStatisticDto[]): AccountData {
  return models.reduce((result, model) => {
    const accountId = model.account.id;

    if (isDefined(accountId)) {
      const pnl = model.volumeInUsd !== 0 ? model.revenueInUsd / model.volumeInUsd : 0;

      result[accountId] = {
        pnl: round(pnl * 100, 3),
        revenue: model.revenueInUsd,
        volume: model.volumeInUsd,
      };
    }

    return result;
  }, {} as AccountData);
}
